<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-space wrap :size="0" class="space-box">
        <div
          style="display: flex"
          v-for="item in props.templateSortFields.filter(
            (w) => w.name != '备注'
          )"
          :key="item"
        >
          <li
            style="
              width: 240px;
              text-align: right;
              background-color: #f5f7fa;
              font-weight: 700;
              color: var(--el-text-color-regular);
              height: 50px;
              padding: 0 10px;
              display: flex;
              align-items: center;
              justify-content: flex-end;
            "
          >
            {{ item.name }}：
          </li>
          <li
            style="
              width: 280px;
              height: 50px;
              padding: 0 10px;
              display: flex;
              align-items: center;
            "
          >
            <el-input-number
              v-if="item.edit"
              v-model="state.model[item.field]"
              :controls="false"
              class="number-input-left number-input-suffix"
              :precision="2"
              suffix="元"
              style="width: 100%"
            ></el-input-number>
            <text v-else>{{ state.model[item.field] || "-" }}</text>
          </li>
        </div>
        <div style="display: flex">
          <li
            style="
              width: 240px;
              text-align: right;
              background-color: #f5f7fa;
              font-weight: 700;
              color: var(--el-text-color-regular);
              padding: 10px;
            "
          >
            备注：
          </li>
          <li style="width: 801px; padding: 10px">
            <el-input
              v-model="state.model[item.field]"
              style="width: 100%"
            ></el-input>
          </li>
        </div>
      </el-space>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { calctaxoutsource_save } from "@/http/calctaxoutsource";
import { ElMessage } from "element-plus";
export default {
  props: {
    templateSortFields: Array,
    item: Object,
    id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({
      model: {},
    });
    onMounted(() => {
      state.model = props.item;
    });

    const onSubmit = (row) => {
      calctaxoutsource_save({
        id: props.id,
        data: JSON.stringify([state.model]),
      }).then((res) => {
        if (res.status == 200) {
          ElMessage.success(res.data.msg);
          emit("success");
        }
      });
      row.isEdit = false;
    };

    return {
      state,
      props,
      onSubmit,
    };
  },
};
</script>
<style lang="less">
.space-box {
  border-top: 1px solid var(--el-border-color-lighter);
  border-left: 1px solid var(--el-border-color-lighter);
  & > div {
    & > div {
      border-right: 1px solid var(--el-border-color-lighter);
      border-bottom: 1px solid var(--el-border-color-lighter);
    }
  }
}
</style>
